<template>
  <div class="paginate-block">
      <div class="float-left">
        <div class="form-group ft-entry">
            <label>Show</label>
            <select class="form-control" v-model="num" @change.prevent="changeSorting(num)">
                <option>10</option>
                <option>20</option>
                <option>50</option>
                <option>100</option>
            </select>
            <label>Data</label>
        </div>
      </div>
      <div class="float-right">
        <div class="show mr-4 d-inline-block">
          <label class="font-weight-bold">Showing {{pagination.from}} to {{pagination.to}} of {{pagination.total}} data</label>
        </div>
        <nav class="d-inline-block">
          <ul class="pagination">
            <li v-if="pagination.current_page > 1" class="page-item">
              <a href="javascript:void(0)" aria-label="Previous" v-on:click.prevent="changePage(pagination.current_page - 1)" class="page-link">
                <i class="uil uil-angle-left"></i>
              </a>
            </li>
            <li v-for="page in pagesNumber" class="page-item" :class="{'active': page == pagination.current_page}" v-bind:key="page">
              <a href="javascript:void(0)" v-on:click.prevent="changePage(page)" class="page-link">{{ page }}</a>
            </li>
            <li v-if="pagination.current_page < pagination.last_page" class="page-item">
              <a href="javascript:void(0)" aria-label="Next" v-on:click.prevent="changePage(pagination.current_page + 1)" class="page-link">
                <i class="uil uil-angle-right"></i>
              </a>
            </li>
          </ul>
        </nav>
      </div>
  </div>
</template>

<script>

  export default{
    data(){
        return {
            num: 10,
        }
    },
    props: {
      pagination: {
          type: Object,
          required: true
      },
      sorting: {
          type: Object,
          required: true,
      }
    },
    computed: {
      pagesNumber() {
        if (!this.pagination.to) {
          return [];
        }
        let from = this.pagination.current_page - this.sorting.offset;
        if (from < 1) {
          from = 1;
        }
        let to = from + (this.sorting.offset * 2);
        if (to >= this.pagination.last_page) {
          to = this.pagination.last_page;
        }
        let pagesArray = [];
        for (let page = from; page <= to; page++) {
          pagesArray.push(page);
        }
          return pagesArray;
      }
    },
    methods : {
      changeSorting(num) {
        this.sorting.num = num;
        this.$emit('paginate');
      },
      changePage(page) {
        this.pagination.current_page = page;
        this.$emit('paginate');
      }
    }
  }
</script>